import * as v from 'valibot';

export const CompletionStatusSchema = v.union([
  v.literal('completed'),
  v.literal('incomplete'),
  v.literal('notAttempted'),
  v.literal('unknown'),
]);

export type TCompletionStatus = v.Output<typeof CompletionStatusSchema>;
